// extracted by mini-css-extract-plugin
var _1 = "QdgXauIxi9KvXEUNDmqL";
export { _1 as "modeShape" }
